"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const RegistrationCustomerMode_1 = __importDefault(require("../enums/RegistrationCustomerMode"));
const SessionStorageIds_1 = __importDefault(require("../enums/SessionStorageIds"));
class RegistrationStore {
    static emptyPersonalData() {
        return {
            countryCode: '',
            department: null,
            email: '',
            firstName: '',
            lastName: '',
            phone: null,
            role: null,
            salutation: '',
            title: null,
        };
    }
    static emptyCompanyData() {
        return {
            address: '',
            city: '',
            company: '',
            countryCode: '',
            taxId: '',
            zip: '',
        };
    }
    static emptyGeneralData() {
        return {
            acceptedNewsletter: false,
            acceptedTermsAndConditions: false,
            checkCustomerId: null,
            checkCustomerType: RegistrationCustomerMode_1.default.existingCustomer,
            checkSerialNumber: null,
            checkZipCode: null,
            checkedCompanyExternalId: null,
            checkedCompanyName: null,
            currentStep: null,
            selectedCountryCode: null,
            selectedReseller: null,
            verificationCode: null,
            verifiedCompanyExternalId: null,
            verifiedCountryCode: null,
        };
    }
    debouncedUpdateSessionStore = (0, debounce_1.debounce)(this.updateSessionStore, 500);
    personal = RegistrationStore.emptyPersonalData();
    company = RegistrationStore.emptyCompanyData();
    general = RegistrationStore.emptyGeneralData();
    internalIsLoading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            company: mobx_1.observable,
            companyData: mobx_1.computed,
            general: mobx_1.observable,
            generalData: mobx_1.computed,
            internalIsLoading: mobx_1.observable,
            loadSessionStorage: mobx_1.action.bound,
            personal: mobx_1.observable,
            personalData: mobx_1.computed,
            resetRegistrationData: mobx_1.action.bound,
            setCompanyData: mobx_1.action.bound,
            setGeneralData: mobx_1.action.bound,
            setPersonalData: mobx_1.action.bound,
            setSelectedCountryCode: mobx_1.action.bound,
            setVerifiedCountryCode: mobx_1.action.bound,
        });
    }
    updateSessionStore() {
        sessionStorage.setItem(SessionStorageIds_1.default.personalData, JSON.stringify(this.personal));
        sessionStorage.setItem(SessionStorageIds_1.default.companyData, JSON.stringify(this.company));
        sessionStorage.setItem(SessionStorageIds_1.default.generalData, JSON.stringify(this.general));
    }
    get personalData() {
        return this.personal;
    }
    get companyData() {
        return this.company;
    }
    get generalData() {
        return this.general;
    }
    get isLoading() {
        return this.internalIsLoading;
    }
    setPersonalData(value) {
        this.personal = {
            ...this.personal,
            ...value,
        };
        this.debouncedUpdateSessionStore();
    }
    setCompanyData(value) {
        this.company = {
            ...this.company,
            ...value,
        };
        this.debouncedUpdateSessionStore();
    }
    setGeneralData(value) {
        this.general = {
            ...this.general,
            ...value,
        };
        this.debouncedUpdateSessionStore();
    }
    setVerifiedCountryCode(value) {
        this.general.verifiedCountryCode = value;
        this.personal.countryCode = value ?? undefined;
        this.company.countryCode = value ?? '';
        this.debouncedUpdateSessionStore();
    }
    setSelectedCountryCode(value) {
        this.general.selectedCountryCode = value;
        this.personal.countryCode = value ?? undefined;
        this.company.countryCode = value ?? '';
        this.debouncedUpdateSessionStore();
    }
    loadSessionStorage() {
        const personalData = sessionStorage.getItem(SessionStorageIds_1.default.personalData);
        const companyData = sessionStorage.getItem(SessionStorageIds_1.default.companyData);
        const generalData = sessionStorage.getItem(SessionStorageIds_1.default.generalData);
        if (personalData) {
            this.personal = JSON.parse(personalData);
        }
        if (companyData) {
            this.company = JSON.parse(companyData);
        }
        if (generalData) {
            this.general = JSON.parse(generalData);
        }
        [
            SessionStorageIds_1.default.oldCompanyInformation,
            SessionStorageIds_1.default.oldNecessaryInformation,
            SessionStorageIds_1.default.oldPersonalInformation,
        ].forEach((id) => {
            sessionStorage.removeItem(id);
        });
    }
    resetRegistrationData() {
        this.personal = RegistrationStore.emptyPersonalData();
        this.company = RegistrationStore.emptyCompanyData();
        this.general = RegistrationStore.emptyGeneralData();
        this.updateSessionStore();
    }
}
exports.default = new RegistrationStore();
